import { FormControl, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { TimeZonePickerV2 } from '@shared/components/TimeZonePickerV2';
import { getFieldMetadata } from '@shared/components/ScheduleEditor/hooks/getFieldMetadata';
import { FieldMetadata } from '@shared/components/ScheduleEditor/hooks/useScheduleFormState';
import type { ScheduleEditorData } from '@shared/components/ScheduleEditor/ScheduleEditor.types';

interface FormTimeZonePickerProps
  extends Readonly<{
    fieldName: keyof ScheduleEditorData;
    state: ScheduleEditorData;
    setValue: (key: keyof ScheduleEditorData, value: string) => void;
    label: string;
    placeholder: string;
    meta: Record<keyof ScheduleEditorData, FieldMetadata>;
    timezoneManuallyChangedRef: React.MutableRefObject<boolean>;
  }> {}

export const FormTimeZonePicker = (props: FormTimeZonePickerProps) => {
  const { state, setValue, fieldName, meta, label, placeholder, timezoneManuallyChangedRef } = props;
  const metadata = getFieldMetadata(fieldName, meta);

  return (
    <FormControl
      label={<TextV2 typographyVariant="label3">{label}</TextV2>}
      isInvalid={metadata.error}
    >
      <TimeZonePickerV2
        value={state.timezone ?? ''}
        onChange={tz => {
          // Mark that user manually changed timezone (not auto-detected from location)
          timezoneManuallyChangedRef.current = true;
          setValue('timezone', tz);
        }}
        placeholder={placeholder}
      />
    </FormControl>
  );
};
